export const LOGIN = '/api/v1/auth/login'
export const LOGOUT = '/api/v1/auth/logout'
export const FORGOT_PASSWORD = '/api/v1/auth/forgot-password'
export const RESET_PASSWORD = '/api/v1/auth/reset-password'
export const AUTH_REFRESH = '/api/v1/auth/refresh'

export const SIGNUP_INITIATE = '/api/v1/signup/initiate'
export const SIGNUP_VALIDATE = '/api/v1/signup/validate/:token'
export const SIGNUP_COMPLETE = '/api/v1/signup/complete'

export const USER_PERMISSION = '/api/v1/permissions/current'

export const GET_COUNTRY = '/api/v1/location/countries'
export const GET_STATE = '/api/v1/location/states'
export const GET_CITY = '/api/v1/location/cities'

export const GET_CP_ADMIN_USER = '/api/v1/channel-partners/cp-admin/user-list'
export const GET_CP_ADMIN_USER_BY_ID = '/api/v1/channel-partners/cp-admin/user/:userId'
export const ADD_CP_ADMIN_USER = '/api/v1/channel-partners/cp-admin/add-user'
export const EDIT_CP_ADMIN_USER = '/api/v1/channel-partners/cp-admin/edit-user/:userId'
export const DELETE_CP_ADMIN_USER = '/api/v1/channel-partners/cp-admin/delete-user/:userId'
export const GET_CP_ADMIN_VERIFY_USER = '/api/v1/channel-partners/cp-admin/verify-user-list'
export const POST_CP_ADMIN_VERIFY_USER = '/api/v1/channel-partners/cp-admin/verify-user-list'
export const GET_COMPANY_VERIFICATION_INFO = '/api/v1/channel-partners/cp-admin/company-verification-info'
export const SEND_TEMP_PASSWORD = '/api/v1/channel-partners/cp-admin/send-temp-password'
export const GET_CP_ADMIN_MULTI_STATUS = '/api/v1/channel-partners/cp-admin/multi-status'
export const CREATE_CP_ADMIN_MULTI_STATUS = '/api/v1/channel-partners/cp-admin/multi-status'
export const UPDATE_CP_ADMIN_MULTI_STATUS = '/api/v1/channel-partners/cp-admin/multi-status/:recordId'
export const DELETE_CP_ADMIN_MULTI_STATUS = '/api/v1/channel-partners/cp-admin/multi-status'

export const GET_USER_PROFILE_BY_ID = '/api/v1/users/id/:userId'
export const UPDATE_USER_PROFILE = '/api/v1/users/profile'
export const UPDATE_USER_PASSWORD = '/api/v1/users/id/:userId/change-password'

export const GET_RESOURCES_CATEGORY = '/api/v1/resources/categories'
export const GET_RESOURCES_CATEGORY_DETAILS = '/api/v1/resources/categories/:itemId'
export const GET_RESOURCES_BY_CATEGORY = '/api/v1/resources/resources/:categoryName'
export const GET_RESOURCES_BY_ITEM = '/api/v1/resources/resources-by-item/:itemId'

export const UPLOAD_INVENTORY = '/api/v1/channel-partners/inventory/uplprocess'
export const GET_INVENTORY = '/api/v1/channel-partners/inventory/searchresult'
export const GET_INVENTORY_AUTOCOMPLETE = '/api/v1/channel-partners/inventory/autocomplete'
export const GET_LEADTIME_LISTPRICE = '/api/v1/channel-partners/prodinfo/prodinfo'

export const FIND_INVOICE = '/api/v1/channel-partners/invoice/search'
export const GET_INVOICE_AUTOCOMPLETE = '/api/v1/channel-partners/invoice/autocomplete'

export const GET_CHANNEL_PARTNERS = '/api/v1/admin/channel-partners'
export const GET_ALL_COMPANIES = '/api/v1/admin/companies'
export const GET_COMPANY_BY_ID = '/api/v1/admin/companies/:id'
export const GET_COMPANY_USERS_BY_ID = '/api/v1/admin/companies/:id/users'

// User Audit APIs
export const GET_CHANNEL_PARTNER_ACCESS_STATS = '/api/v1/user-audit/channel-partner-access-stats'

export const GET_CHANNEL_PARTNERS_BY_ID = '/api/v1/admin/channel-partners/:id'
export const GET_CHANNEL_PARTNERS_USERS_BY_ID = '/api/v1/admin/channel-partners/:id/users'
export const ADD_CHANNEL_PARTNETS_USER = '/api/v1/admin/users'
export const GET_CHANNEL_PARTNERS_UPLOAD_DATES ='/api/v1/channel-partners/inventory/updatecheck'
export const DELETE_CHANNEL_PARTNETS_USER ='/api/v1/admin/channel-partners/users/:userId'
export const EDIT_CHANNEL_PARTNERS_USER ='/api/v1/admin/channel-partners/users/:userId'
export const GET_CHANNEL_PARTNERS_USERS_BY_USERID ='/api/v1/admin/channel-partners/users/:userId'
export const GET_CHANNEL_PARTNERS_USERLIST_ON_FILTER = '/api/v1/admin/channel-partner-users'
export const DELETE_USER_CHANNEL_PARTNER_USERLIST ='/api/v1/admin/channel-partners/users/:userId'

export const GETLOGIN = '/login/:accountId'

export const GET_COMPANY_CUSTOMER_VIEW_ORDERS = '/api/v1/company/customers/view-orders'
export const GET_COMPANY_CUSTOMER_OPEN_ORDER = '/api/v1/channel-partners/ostatus/listopen/open'
export const GET_COMPANY_CUSTOMER_CLOSE_ORDER = '/api/v1/channel-partners/ostatus/listopen/closed'
export const GET_COMPANY_OPEN_ITEM = '/api/v1/channel-partners/ostatus/openitems'
export const GET_COMPANY_ORDER_STATUS = '/api/v1/channel-partners/ostatus/status'
export const GET_COMPANY_PURCHASE_ORDER_STATUS = '/api/v1/channel-partners/ostatus/status'
export const GET_COMPANY_ORDER_STATUS_LIST = '/api/v1/channel-partners/ostatus/status/list'
export const GET_ORDER_STATUS_SO_AUTOCOMPLETE = '/api/v1/channel-partners/ostatus/autocomplete/so'
export const GET_ORDER_STATUS_PO_AUTOCOMPLETE = '/api/v1/channel-partners/ostatus/autocomplete/po'

export const GET_CHANNEL_PARTNER_OENTRY_HEADER = '/api/v1/channel-partners/oentry/header'
export const POST_CHANNEL_PARTNER_OENTRY_HEADER = '/api/v1/channel-partners/oentry/header'
export const GET_COMPANY_CHANNEL_PARTNER = '/api/v1/channel-partners/oentry/channel-partners'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL = '/api/v1/channel-partners/oentry/products/:partNumber/details'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_SEARCH = '/api/v1/channel-partners/oentry/products/search'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_AUTOCOMPLETE = '/api/v1/channel-partners/oentry/products/autocomplete'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_SET_POINT = '/api/v1/channel-partners/oentry/products/:partNumber/setpoints'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_LEAD_TIME = '/api/v1/channel-partners/oentry/products/:partNumber/leadtime'
export const POST_CHANNEL_PARTNER_OENTRY_HEADER_CART_ADD = '/api/v1/channel-partners/oentry/cart/add'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_CART = '/api/v1/channel-partners/oentry/cart'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_CANCEL = '/api/v1/channel-partners/oentry/cancel'
export const GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SUBMIT = '/api/v1/channel-partners/oentry/order/submit'
export const PATCH_CHANNEL_PARTNER_OENTRY_HEADER_CART = '/api/v1/channel-partners/oentry/cart/:partNumber'
export const DELETE_CHANNEL_PARTNER_OENTRY_HEADER_REMOVE_CART = '/api/v1/channel-partners/oentry/cart/:partNumber'

export const GET_RECENT_INVENTORY_SEARCH = '/api/v1/user-audit/my/recent-inventory-searches'
export const GET_RECENT_INVOICE_SEARCH = '/api/v1/user-audit/my/recent-invoice-searches'
export const GET_RECENT_ORDER_SEARCH ='/api/v1/user-audit/my/recent-order-searches'

// On-Behalf User Management APIs
export const GET_ON_BEHALF_USERS = '/api/v1/admin/on-behalf-users';
export const GET_ON_BEHALF_USER_BY_ID = (id) => `/api/v1/admin/on-behalf-users/${id}`;
export const CREATE_ON_BEHALF_USER = '/api/v1/admin/on-behalf-users';
export const UPDATE_ON_BEHALF_USER = (id) => `/api/v1/admin/on-behalf-users/${id}`;
export const DELETE_ON_BEHALF_USER = (id) => `/api/v1/admin/on-behalf-users/${id}`;
export const GET_ELIGIBLE_USER_IDS = '/api/v1/admin/on-behalf-users/eligible-ids';
export const GET_AVAILABLE_USERS = '/api/v1/admin/on-behalf-users/available-users';
export const BULK_IMPORT_ON_BEHALF_USERS = '/api/v1/admin/on-behalf-users/bulk-import';